/// <amd-module name="VSS/Redux/Deprecated/HubViewState/HubViewStateContracts" />
import { IFilterState } from "VSSUI/Utilities/Filter";
import { IViewOptionsValues } from "VSSUI/Utilities/ViewOptions";

export interface IHubViewAwareState {
    hubViewState: IHubViewState;
}

export interface IHubViewState {
    currentPivot: string;
    currentFilterState: IFilterState;
    currentViewOptions: IViewOptionsValues;
}
